// reducers/listOfColumnsReducer.js

import * as actionType from "../constants/actionTypes";

const initialState = {
  columns: [],
  loading: false, // optional if not handling loading state
  error: null,
  message: "",
};

const listOfColumnsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_LIST_OF_COLUMNS:
      return {
        ...state,
        columns: action.payload,
        loading: false,
        error: null,
        message: "Fetched successfully",
      };

    default:
      return state;
  }
};

export default listOfColumnsReducer;
